import React, { useCallback, useMemo, useState } from 'react';
import { withStyles } from 'tss-react/mui';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';

import ApiService from '@common/services/ApiService';
import AdminTable from '@common/components/table/AdminTable';
import ApproveModal from './ApproveModal';
import RejectModal from './RejectModal';
import ButtonActions from './ButtonActions';

const styles = theme => ({
  exportHeader: {
    padding: `${theme.typography.pxToRem(22)} ${theme.typography.pxToRem(
      25
    )} ${theme.typography.pxToRem(25)} ${theme.typography.pxToRem(25)}`
  },
  headline: {
    marginTop: theme.typography.pxToRem(8),
    marginBottom: theme.typography.pxToRem(35)
  },
});

const RegistrationList = ({ user, institute, classes, ...props}) => {
  const [registration, setRegistration] = useState(undefined)
  const [isApproveModalOpened, setIsApproveModalOpened] = useState(false);
  const [isRejectModalOpened, setIsRejectModalOpened] = useState(false);
  const [refreshTick, setRefreshTick] = useState(0);
  const [filters, setFilter] = useState({ status_eq: 'pending'})
  const [api, setApi] = useState(new ApiService());

  const fields = useMemo(() => {
    const arr = [];

    arr.push('created_at', 'program_name', 'program_start_date', 'user_name');

    if (institute?.custom_user_field_1_enabled && institute?.custom_user_field_1_on_registrations) {
      arr.push('custom_1');
    }

    if (institute?.custom_user_field_2_enabled && institute?.custom_user_field_2_on_registrations) {
      arr.push('custom_2');
    }

    arr.push('supervisor_name');

    return arr;
  }, [institute]);

  const handleRefresh = useCallback(() => {
    setRefreshTick(Date.now());
  }, [setRefreshTick]);

  const toggleApproveModal = useCallback(registration => {
    setRegistration(registration);
    setIsApproveModalOpened(registration !== undefined)
  }, [setRegistration, setIsApproveModalOpened]);

  const toggleRejectModal = useCallback(registration => {
    setRegistration(registration);
    setIsRejectModalOpened(registration !== undefined)
  }, [setRegistration, setIsRejectModalOpened]);

  const handleExport = useMemo(() => {
    return api.fullUrl(`/api/v2/registrations.csv`, filters, null, null, {}, false);
  });

  const renderButtonActions = useCallback((registration) => {
    return <ButtonActions registration={registration} toggleApproveModal={toggleApproveModal} toggleRejectModal={toggleRejectModal} />
  }, [toggleApproveModal, toggleRejectModal]);

  const renderAdminTable = useMemo(() => {
    return (
      <AdminTable
        showTablePagination
        fields={fields}
        filters={filters}
        actionsSection={['buttons']}
        renderButtonActions={renderButtonActions}
        resource="registrations"
        url="/api/v2/registrations"
        refreshTick={refreshTick}
      />
    )
  }, [fields, refreshTick]);

  return (
    <Grid container spacing={2}>
      <Grid size={12}>
        <Typography className={classes.headline} variant="h5">
          Registrations submitted for approval
        </Typography>
      </Grid>
      <Grid size={12}>
        <Paper>
          <Grid container className={classes.exportHeader} justifyContent="space-between" >
            <Typography variant="h6">Registrations</Typography>
            <a href={handleExport} target="_blank">
              <Button color="secondary" size="small" variant="contained">
                <Typography variant="button">Export</Typography>
              </Button>
            </a>
          </Grid>
          {renderAdminTable}
        </Paper>
        <ApproveModal
          isOpened={isApproveModalOpened}
          onClose={toggleApproveModal}
          registration={registration}
          onRefreshRequest={handleRefresh}
        />
        <RejectModal
          isOpened={isRejectModalOpened}
          onClose={toggleRejectModal}
          registration={registration}
          onRefreshRequest={handleRefresh}
        />
      </Grid>
    </Grid>
  );
}

export default withStyles(RegistrationList, styles, { withTheme: true });
